export const css = {
	root: '_3wxxw4cr',
	pane: '_2yMmkTLz',
	heading: '_74otBsk',
	body: '_1f1aFijk',
	exit: '_1m-KpIC3',
	collapse: '_1nftTnjd',
	enter: '_21LAe76S',
	expand: '_3QOUxXAi',
	' _key': 'apic-theme/apic/base-widgets/accordion2'
};

export default css;
